import React from 'react';
import * as S from './style';
import { colorCodes } from './data';
const Filter = ({activeIndex, filterHandler, gradeMap}) => {
  
  const grade = gradeMap || [];
  return (
    <S.FilterWrapper>
      <S.FilterList>
        <S.ListItem>Grade</S.ListItem>
        {
          grade.map( (val,index) => {
            const selectedGrade = activeIndex === index;
            const bgColor = selectedGrade ? colorCodes[index].dark : colorCodes[index].light;
            const selectedColor = colorCodes[index].light;
            {/* const { code } = gradeMap[index] */}
            return <S.ListItem bgColor={bgColor} selectedColor={selectedColor} selected={selectedGrade} onClick={()=>filterHandler({index, gradeId:val.title})}>{val.title === 'pk' ? 'Pre-K' : val.title}</S.ListItem>
          })
        }
      </S.FilterList>
    </S.FilterWrapper>
  )
}

export default Filter;